// extracted by mini-css-extract-plugin
export var boxItems = "_6b-1";
export var boxItemsLg = "_6b-2";
export var button = "_6b-7";
export var buttonHoverless = "_6b-9";
export var buttonLg = "_6b-8";
export var filterGroupBox = "_6b-0";
export var icon = "_6b-3";
export var iconSecondary = "_6b-6";
export var iconWrapper = "_6b-4";
export var iconWrapperLg = "_6b-5";
export var truncatedLabel = "_6b-a";